import { compact } from '@lglp/utils';
import { has, map, prop, propOr } from 'ramda';

import { date as dateParser } from '../../../../helpers/compact';
import { DocumentType } from '../../../../types/document';
import { toLinkFromProp } from '../../fields/link';
import { processFinancialFooter } from './financial/financial-footer';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicFinancialRating
 */

/**
 * @typedef {DocumentSchema} FinancialRatingSchema
 */

const date = (propname, data) =>
  has(propname, data) &&
  dateParser(prop(propname, data), 'YYYY-MM-DDTHH:mm:ssZ');

/**
 * Transform the given input into objects
 *
 * @param  {PrismicFinancialDebt} data
 * @return {FinancialDebtSchema}
 */
const processTab = map((entry) =>
  compact({
    title: prop('title', entry),
    lastRevision: date('last_revision', entry),
    longTerm: prop('long_term', entry),
    shortTerm: prop('short_term', entry),
    outlook: prop('outlook', entry),
    file: toLinkFromProp('file', entry),
    link: toLinkFromProp('link', entry),
  })
);

/**
 * Transform the given input into objects
 *
 * @param  {PrismicFinancialRating} data
 * @return {FinancialRatingSchema}
 */
const processFinancialRating = (data) =>
  compact({
    uid: DocumentType.FINANCIAL_RATING,
    type: DocumentType.FINANCIAL_RATING,
    ...processFinancialFooter(data),
    financial: processTab(propOr([], 'financial', data)),
    rse: processTab(propOr([], 'rse', data)),
  });

/**
 * Normalizr schema representing a financial rating page
 */
export const FinancialRatingEntity = deprecatedPageEntity(
  DocumentType.FINANCIAL_RATING,
  {
    processStrategy: (entity) => ({
      ...processFinancialRating(prop('data', entity)),
    }),
  }
);
